import axios from "axios";
import { API } from "../constant";
import { enqueueSnackbar } from "notistack";

export const generalApi = axios.create({
    baseURL: API.BASE_URL,
    withCredentials: false
})

generalApi.interceptors.request.use(
    async (config) => {
        config.headers.Accept = "application/json";
        config.headers["Content-Type"] = "application/json";

        return config;
    },
    (err) => Promise.reject(err),
);

generalApi.interceptors.response.use(
    (response) => response,
    async (err) => {
        console.log(err);
        enqueueSnackbar({
            message: err.message,
            variant: "error",
        })
    },
);
